import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CATEGORIES } from "../../data/menu";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("espresso");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px" }
    );
    CATEGORIES.forEach((c) => {
      const el = document.getElementById(c.id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, []);

  const handleClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1.1, delay: 1.6, ease: [0.19, 1, 0.22, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-ink/70 border-b border-bone/10 py-4"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex items-center justify-between">
        <a
          data-testid="site-logo"
          href="#top"
          onClick={(e) => handleClick(e, "top")}
          className="font-serif italic text-bone text-xl md:text-2xl tracking-tightest leading-none"
        >
          Ferrum <span className="text-gold">&amp;</span> Ember
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {CATEGORIES.map((c) => (
            <a
              key={c.id}
              href={`#${c.id}`}
              data-testid={`nav-link-${c.id}`}
              onClick={(e) => handleClick(e, c.id)}
              className="group relative text-[11px] uppercase tracking-widest-2 text-bone/70 hover:text-bone transition-colors duration-500"
            >
              <span className="text-gold/70 mr-2 font-mono">{c.number}</span>
              {c.title}
              <span
                className={`absolute -bottom-2 left-0 h-px bg-gold transition-all duration-500 ${
                  active === c.id ? "w-full" : "w-0 group-hover:w-full"
                }`}
              />
            </a>
          ))}
        </nav>

        <span
          data-testid="nav-hours"
          className="hidden md:block text-[11px] uppercase tracking-widest-2 text-bone/50"
        >
          Open · 07 — 19
        </span>
      </div>
    </motion.header>
  );
};
